import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SnRequestedUser } from '@lib/api/entities';
import { PublicOrganization } from '@lib/auth/public';

@Injectable({ providedIn: 'root' })
export class SnRequestedUsersAPI {
  public public;

  constructor(private readonly _httpClient: HttpClient) {}

  public createRequestedUser(data: any): Observable<SnRequestedUser> {
    return this._httpClient
      .post('/api/public/users/requested-users/', data)
      .pipe(map((response: any) => new SnRequestedUser(response)));
  }

  public getRequestedUser(email: string): Observable<SnRequestedUser> {
    return this._httpClient
      .get(`/api/public/users/requested-users/${email}`)
      .pipe(map((response: any) => new SnRequestedUser(response)));
  }

  public getPublicOrganization(prefix: string): Observable<PublicOrganization> {
    return this._httpClient
      .get(`/api/public/organizations/${prefix}/`)
      .pipe(map((response: any) => new PublicOrganization(response)));
  }
}
